import { Input, Button, Col, Row } from "reactstrap";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../constants/api.constants";
import { FormattedMessage } from "react-intl";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

export default function DeleteResults() {
  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col xs="3" className="mb-2">
          <h5 className="no-margin">
            <FormattedMessage id="DeleteResult" />
          </h5>
        </Col>
      </Row>
      <Row>
        <Col xs="3" className="mb-2">
          <Input id="result-delete-email" placeholder="elev-email" />
        </Col>
      </Row>
      <Row>
        <Col xs="3" className="mb-2">
          <Input
            id="result-delete-course"
            placeholder="kurs-namn"
            style={{ width: "450px" }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs="3" className="mb-2">
          <Input
            id="result-delete-module"
            placeholder="modul-namn (lämna tomt om hela kursens resultat ska raderas)"
            style={{ width: "450px" }}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            color="primary"
            outline
            id="button-delete-results"
            onClick={() => {
              var button = document.getElementById("button-delete-results");
              button.disabled = true;

              var mail = document
                .getElementById("result-delete-email")
                .value.trim();
              var course = document
                .getElementById("result-delete-course")
                .value.trim();
              var module = document
                .getElementById("result-delete-module")
                .value.trim();

              axios
                .delete(
                  `${API_BASE_URL}/StudentResult/DeleteResult?studentEmail=${encodeURIComponent(
                    mail
                  )}&courseName=${course}&moduleName=${module}`
                )
                .then((response) => {
                  if (response?.data?.result) {
                    toast.success(response.data.result, TOAST_CONFIG);
                  } else {
                    toast.warn("Svaret från servern var oväntat", TOAST_CONFIG);
                  }

                  button.disabled = false;
                })
                .catch((err) => {
                  var failMessage = err?.response?.data
                    ? err.response.data
                    : err;
                  toast.warn(failMessage, TOAST_CONFIG);

                  button.disabled = false;
                });
            }}
          >
            <FormattedMessage id="Delete" />
          </Button>
        </Col>
      </Row>
    </div>
  );
}
